var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "global-page-base-layout",
    },
    [
      _c("Caseconditons", {
        attrs: { caseReplyCondition: false },
        on: { choose: _vm.checkList, cleanCondition: _vm.cleanConditionData },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "judge-all-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.multipleSelection.length <= 0 },
              on: { click: _vm.batchCheck },
            },
            [_vm._v("批量生成裁决书")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "handing-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "案号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.caseNo
                          ? _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.caseNo))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v("暂无案号")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "caseId", label: "受理号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerApplyTime", label: "申请日期" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appName", label: "申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "resName", label: "被申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationReason", label: "案由" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "controversyAmount", label: "争议金额(元)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationAmount", label: "仲裁费(元)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: "案件状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.caseState[scope.row.state]) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "handingSecretaryName", label: "办案秘书" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitratorName", label: "仲裁员" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerSendTime", label: "立案时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleReview(scope.row)
                              },
                            },
                          },
                          [_vm._v("[编辑裁决书]")]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpload(scope.row)
                              },
                            },
                          },
                          [_vm._v("[上传裁决书]")]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.uploadDecision(scope.row)
                              },
                            },
                          },
                          [_vm._v("[上传撤案决定书]")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传撤案决定书",
            visible: _vm.uploadDecisionVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadDecisionVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "附件：" } },
                [
                  _c(
                    "el-link",
                    {
                      staticClass: "margin-right",
                      attrs: {
                        type: "primary",
                        underline: false,
                        href: _vm.uploadRule.aliyunOssHref,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.uploadRule.fileName) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { display: "inline-block" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            accept: ".pdf,.PDF,.docx,.DOCX",
                            action: _vm.uploadApi,
                            "show-file-list": false,
                            headers: { Authorization: _vm.token },
                            "on-success": _vm.handleAvatarSuccess,
                            "before-upload": _vm.beforeAvatarUpload,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "medium", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("br"),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "65px" } }, [
                _vm._v(
                  "注：仲裁委对案件作出撤案处理时，需上传决定书并送达双方。"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.uploadDecisionVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.singleUploading },
                  on: { click: _vm.handleUploadDecisionSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传裁决书",
            visible: _vm.uploadVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "附件：" } },
                [
                  _c(
                    "el-link",
                    {
                      staticClass: "margin-right",
                      attrs: {
                        type: "primary",
                        underline: false,
                        href: _vm.uploadRule.aliyunOssHref,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.uploadRule.fileName) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { display: "inline-block" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            accept: ".pdf,.PDF,.docx,.DOCX,.doc,.DOC",
                            action: _vm.uploadApi,
                            "show-file-list": false,
                            headers: { Authorization: _vm.token },
                            "on-success": _vm.handleAvatarSuccess,
                            "before-upload": _vm.beforeAvatarUpload,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "medium", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.uploadVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.singleUploading },
                  on: { click: _vm.handleUploadSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量上传裁决书",
            visible: _vm.batchUploadVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchUploadVisible = $event
            },
          },
        },
        [
          _c("div", [
            _vm._v("（温馨提示：文件不能超过100MB，支持文件格式：zip）"),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { display: "inline-block" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    accept: ".zip",
                    action: _vm.batchUploadApi,
                    "show-file-list": false,
                    headers: { Authorization: _vm.token },
                    "on-success": _vm.handleBatchUploadSuccess,
                    "before-upload": _vm.beforeBatchUpload,
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "medium", type: "primary" } },
                    [_vm._v("点击上传")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchUploadVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "裁决书",
            visible: _vm.upcomingVisible,
            top: "0vh",
            fullscreen: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.upcomingVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            {
              staticClass: "case-detail",
              staticStyle: { "padding-right": "10px" },
            },
            [
              _c(
                "el-col",
                {
                  staticClass: "detail",
                  staticStyle: { "padding-right": "30px" },
                  attrs: { span: 12 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple left-content" },
                    [
                      _c(
                        "div",
                        { staticClass: "anchor", attrs: { id: "caseAbout" } },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v("案件概况"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "案件受理号：" +
                                      _vm._s(_vm.detailData.caseId)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "提交时间：" + _vm._s(_vm.detailData.ctime)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "案由：" + _vm._s(_vm.detailData.reason)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "办案秘书：" +
                                      _vm._s(
                                        _vm.detailData.handlingSecretaryName
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "仲裁费：" +
                                      _vm._s(_vm.detailData.arbitrationAmount)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "案号：" + _vm._s(_vm.detailData.caseNo)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "立案时间：" +
                                      _vm._s(_vm.detailData.registerTime)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "适用程序：" +
                                      _vm._s(_vm.detailData.applicableProcedure)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "标的额：" +
                                      _vm._s(_vm.detailData.controversyAmount)
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "anchor", attrs: { id: "casePerson" } },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v("当事人信息"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c("el-col", { attrs: { span: 24 } }, [
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v("申请人：\n                  "),
                                    _vm.detailData.appPartyList == ""
                                      ? _c("span", [_vm._v("暂无")])
                                      : _vm._l(
                                          _vm.detailData.appPartyList,
                                          function (app) {
                                            return _c(
                                              "el-link",
                                              {
                                                staticClass: "margin-right20",
                                                attrs: {
                                                  type: "primary",
                                                  underline: false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getPartyInfo(
                                                      app.partyId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(app.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v(
                                      "申请人代理人：\n                  "
                                    ),
                                    _vm.detailData.appProxyList == ""
                                      ? _c("span", [_vm._v("暂无")])
                                      : _vm._l(
                                          _vm.detailData.appProxyList,
                                          function (appProxy) {
                                            return _c(
                                              "el-link",
                                              {
                                                staticClass: "margin-right20",
                                                attrs: {
                                                  type: "primary",
                                                  underline: false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getPartyInfo(
                                                      appProxy.partyId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(appProxy.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v("被申请人：\n                  "),
                                    _vm.detailData.resPartyList == ""
                                      ? _c("span", [_vm._v("暂无")])
                                      : _vm._l(
                                          _vm.detailData.resPartyList,
                                          function (res) {
                                            return _c(
                                              "el-link",
                                              {
                                                staticClass: "margin-right20",
                                                attrs: {
                                                  type: "primary",
                                                  underline: false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getPartyInfo(
                                                      res.partyId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(res.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v(
                                      "被申请人代理人：\n                  "
                                    ),
                                    _vm.detailData.resProxyList == ""
                                      ? _c("span", [_vm._v("暂无")])
                                      : _vm._l(
                                          _vm.detailData.resProxyList,
                                          function (resProxy) {
                                            return _c(
                                              "el-link",
                                              {
                                                staticClass: "margin-right20",
                                                attrs: {
                                                  type: "primary",
                                                  underline: false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getPartyInfo(
                                                      resProxy.partyId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(resProxy.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "anchor", attrs: { id: "caseItem" } },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v("仲裁事项"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c("el-col", { attrs: { span: 24 } }, [
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v("仲裁请求：\n                  "),
                                    _c(
                                      "span",
                                      { staticClass: "text-ellipsis" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detailData.arbitrationRequest
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "top",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { width: "300px" },
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detailData
                                                  .arbitrationRequest
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.arbitrationRequestFlag,
                                                expression:
                                                  "arbitrationRequestFlag",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                          },
                                          [_vm._v("显示全部")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v("事实和理由：\n                  "),
                                    _c(
                                      "span",
                                      { staticClass: "text-ellipsis" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detailData.arbitrationAruth
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "top",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { width: "300px" },
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.detailData.arbitrationAruth
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.arbitrationAruthFlag,
                                                expression:
                                                  "arbitrationAruthFlag",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                          },
                                          [_vm._v("显示全部")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "anchor",
                          attrs: { id: "caseMaterial" },
                        },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v("申请人案件材料"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        "margin-left": "10px",
                                      },
                                      attrs: { data: _vm.MaterialData1 },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "partyName",
                                          label: "提交人",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "fileName",
                                          label: "名称",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      underline: false,
                                                      href: scope.row
                                                        .aliyunOssHref,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          scope.row.fileName
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "discernState",
                                          label: "识别状态",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.discernState == "-1"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.identiyState[
                                                              scope.row
                                                                .discernState
                                                            ]
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.identiyState[
                                                            scope.row
                                                              .discernState
                                                          ]
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "header" }, [
                            _vm._v("被申请人案件材料"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        "margin-left": "10px",
                                      },
                                      attrs: { data: _vm.MaterialData2 },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "submitUserName",
                                          label: "提交人",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "fileName",
                                          label: "名称",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      underline: false,
                                                      href: scope.row
                                                        .aliyunOssHref,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          scope.row.fileName
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "discernState",
                                          label: "识别状态",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.discernState == "-1"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.identiyState[
                                                              scope.row
                                                                .discernState
                                                            ]
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.identiyState[
                                                            scope.row
                                                              .discernState
                                                          ]
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "anchor",
                          attrs: { id: "resInformation" },
                        },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v("答辩信息"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c("el-col", { attrs: { span: 24 } }, [
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v("答辩状：\n                  "),
                                  _vm.caseReply.content == ""
                                    ? _c("span", [_vm._v("暂无")])
                                    : _c(
                                        "div",
                                        { staticClass: "caseItem-txt" },
                                        [_vm._v(_vm._s(_vm.caseReply.content))]
                                      ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "case-txt" },
                                  [
                                    _vm._v("答辩材料：\n                  "),
                                    _vm.caseReply.replyName == ""
                                      ? _c("span", [_vm._v("暂无")])
                                      : _c(
                                          "el-link",
                                          {
                                            staticClass: "margin-right20",
                                            attrs: {
                                              type: "primary",
                                              underline: false,
                                              href: _vm.caseReply.aliyunOssHref,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.caseReply.replyName) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "anchor",
                          attrs: { id: "holdInformation" },
                        },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v("仲裁庭信息"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-main",
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "仲裁委指定仲裁员：" +
                                      _vm._s(
                                        _vm.courtInfo.arbitratorName
                                          ? _vm.courtInfo.arbitratorName
                                          : "暂无"
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "被申请人选择仲裁员：" +
                                      _vm._s(
                                        _vm.courtInfo.resArbitratorName
                                          ? _vm.courtInfo.resArbitratorName
                                          : "暂无"
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "申请人选择仲裁员：" +
                                      _vm._s(
                                        _vm.courtInfo.appArbitratorName
                                          ? _vm.courtInfo.appArbitratorName
                                          : "暂无"
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.courtInfo.secondArbitratorName
                                  ? _c("div", { staticClass: "case-txt" }, [
                                      _vm._v(
                                        "\n                  仲裁员2名字（适用于合议庭）：" +
                                          _vm._s(
                                            _vm.courtInfo.secondArbitratorName
                                          ) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.courtInfo.thirdArbitratorName
                                  ? _c("div", { staticClass: "case-txt" }, [
                                      _vm._v(
                                        "\n                  仲裁员3名字（适用于合议庭）：" +
                                          _vm._s(
                                            _vm.courtInfo.thirdArbitratorName
                                          ) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm.courtInfo.courtTime
                                  ? _c("div", { staticClass: "case-txt" }, [
                                      _vm._v(
                                        "开庭时间：" +
                                          _vm._s(_vm.courtInfo.courtTime)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.courtInfo.courtAddress
                                  ? _c("div", { staticClass: "case-txt" }, [
                                      _vm._v(
                                        "开庭地点：" +
                                          _vm._s(_vm.courtInfo.courtAddress)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "组庭时间：" +
                                      _vm._s(
                                        _vm.courtInfo.composeTime
                                          ? _vm.courtInfo.composeTime
                                          : "暂无"
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "case-txt" }, [
                                  _vm._v(
                                    "审理方式：" +
                                      _vm._s(
                                        _vm.courtInfo.trialWay
                                          ? _vm.courtInfo.trialWay
                                          : "暂无"
                                      )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "left-content", attrs: { id: "rule" } },
                  [
                    _c("div", [
                      _c(
                        "textarea",
                        {
                          staticClass: "rule-header",
                          staticStyle: { resize: "none" },
                          attrs: {
                            id: "subject",
                            rows: "1",
                            placeholder: "请输入裁决书主题",
                          },
                        },
                        [_vm._v(_vm._s(_vm.caseAwardContentDto.subject))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "textarea",
                        {
                          staticClass: "rule-header",
                          staticStyle: { resize: "none" },
                          attrs: {
                            id: "title",
                            rows: "1",
                            placeholder: "请输入裁决书标题",
                          },
                        },
                        [_vm._v(_vm._s(_vm.caseAwardContentDto.title))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "textarea",
                        {
                          staticClass: "rule-caseno",
                          staticStyle: { resize: "none" },
                          attrs: {
                            id: "caseNo",
                            rows: "1",
                            placeholder: "请输入裁决书编号",
                          },
                        },
                        [_vm._v(_vm._s(_vm.caseAwardContentDto.caseNo))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [
                        _vm.partyInfos.title
                          ? _c(
                              "textarea",
                              {
                                staticClass: "rule-title",
                                attrs: {
                                  id: "title1",
                                  placeholder: "请输入小标题",
                                },
                              },
                              [_vm._v(_vm._s(_vm.partyInfos.title))]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "rule1" } },
                        _vm._l(_vm.partyInfos.content, function (item, index) {
                          return _c(
                            "div",
                            [
                              _c("el-input", {
                                staticClass: "rule-input",
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  placeholder: "请输入内容",
                                },
                                model: {
                                  value: item.text,
                                  callback: function ($$v) {
                                    _vm.$set(item, "text", $$v)
                                  },
                                  expression: "item.text",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "p-btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "red" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete1(index)
                                        },
                                      },
                                    },
                                    [_vm._v("[删除]")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAdd1(index)
                                        },
                                      },
                                    },
                                    [_vm._v("[新增]")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [
                        _vm.partyContents.title
                          ? _c(
                              "textarea",
                              {
                                staticClass: "rule-title el-textarea__inner",
                                attrs: {
                                  id: "title2",
                                  placeholder: "请输入小标题",
                                },
                              },
                              [_vm._v(_vm._s(_vm.partyContents.title))]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "rule2" } },
                        _vm._l(
                          _vm.partyContents.content,
                          function (item, index) {
                            return _vm.partyContents.content.length !== 0
                              ? _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticClass: "rule-input",
                                      attrs: {
                                        type: "textarea",
                                        autosize: "",
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: item.text,
                                        callback: function ($$v) {
                                          _vm.$set(item, "text", $$v)
                                        },
                                        expression: "item.text",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "p-btn" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "red" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete2(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[删除]")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAdd2(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[新增]")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [
                        _vm.caseContents.title
                          ? _c(
                              "textarea",
                              {
                                staticClass: "rule-title",
                                attrs: {
                                  id: "title3",
                                  placeholder: "请输入小标题",
                                },
                              },
                              [_vm._v(_vm._s(_vm.caseContents.title))]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "rule3" } },
                        _vm._l(
                          _vm.caseContents.content,
                          function (item, index) {
                            return _vm.caseContents.content.length !== 0
                              ? _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticClass: "rule-input",
                                      attrs: {
                                        type: "textarea",
                                        autosize: "",
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: item.text,
                                        callback: function ($$v) {
                                          _vm.$set(item, "text", $$v)
                                        },
                                        expression: "item.text",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "p-btn" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "red" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete3(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[删除]")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAdd3(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[新增]")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [
                        _vm.arbitrationContents.title
                          ? _c(
                              "textarea",
                              {
                                staticClass: "rule-title",
                                attrs: {
                                  id: "title4",
                                  placeholder: "请输入小标题",
                                },
                              },
                              [_vm._v(_vm._s(_vm.arbitrationContents.title))]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "rule4" } },
                        _vm._l(
                          _vm.arbitrationContents.content,
                          function (item, index) {
                            return _vm.arbitrationContents.content.length !== 0
                              ? _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticClass: "rule-input",
                                      attrs: {
                                        type: "textarea",
                                        autosize: "",
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: item.text,
                                        callback: function ($$v) {
                                          _vm.$set(item, "text", $$v)
                                        },
                                        expression: "item.text",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "p-btn" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "red" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete4(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[删除]")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAdd4(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[新增]")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [
                        _vm.ruleContents.title
                          ? _c(
                              "textarea",
                              {
                                staticClass: "rule-title",
                                attrs: {
                                  id: "title5",
                                  placeholder: "请输入小标题",
                                },
                              },
                              [_vm._v(_vm._s(_vm.ruleContents.title))]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "rule5" } },
                        _vm._l(
                          _vm.ruleContents.content,
                          function (item, index) {
                            return _vm.ruleContents.content.length !== 0
                              ? _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      staticClass: "rule-input",
                                      attrs: {
                                        type: "textarea",
                                        autosize: "",
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: item.text,
                                        callback: function ($$v) {
                                          _vm.$set(item, "text", $$v)
                                        },
                                        expression: "item.text",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "p-btn" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "red" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete5(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[删除]")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAdd5(index)
                                              },
                                            },
                                          },
                                          [_vm._v("[新增]")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-right",
              staticStyle: { "padding-top": "10px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.upcomingVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingSave },
                  on: {
                    click: function ($event) {
                      return _vm.handleSave("1")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", loading: _vm.loadingShow },
                  on: {
                    click: function ($event) {
                      return _vm.handleSave("2")
                    },
                  },
                },
                [_vm._v("保存&预览")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", loading: _vm.loadingPass },
                  on: {
                    click: function ($event) {
                      return _vm.handleSave("3")
                    },
                  },
                },
                [_vm._v("保存&通过")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("party-info", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.partyInfoVisible,
            expression: "partyInfoVisible",
          },
        ],
        ref: "partyInfo",
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "裁决书拒绝",
            visible: _vm.refuseVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.refuseVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "refuseForm",
              attrs: { model: _vm.refuseForm, rules: _vm.refuseRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "opinion" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "5",
                      placeholder: "请输入拒绝理由",
                      resize: "none",
                    },
                    model: {
                      value: _vm.refuseForm.opinion,
                      callback: function ($$v) {
                        _vm.$set(_vm.refuseForm, "opinion", $$v)
                      },
                      expression: "refuseForm.opinion",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.refuseVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleRefuseSubmit("refuseForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }